import React,{useRef,useCallback,useEffect} from 'react'
import {useSpring, animated} from 'react-spring'
import styled from 'styled-components'
import theme from '../../themes'
import { MdClose } from 'react-icons/md'
import ContactUs from '../emailsend';
import { Marginer } from '../marginer'




const Background = styled.div`
width:50%;
height:100%;
background:${theme.primary};
margin-top:-50px;
display:flex;
justify-content:center;
align-items:center;
padding:5px;
z-index:90;



@media screen and (max-width:580px){
    width:100%;
    height:100%;
    justify-content:center;
    align-items:center;
}
`


const ModalWrapper = styled.div`
width:100%;
height:100%;
box-shadow:0 5px 16px rgba(0, 0 , 0 ,0.2);
background:#fff;
color:${theme.white};
display:flex;
flex-direction:column;
position:relative;
z-index:10;
border-radius:10px;
`
const ModalContent = styled.div`
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
line-height:1.8;
color:#141414;

p{
    margin-bottom:1rem;
}

button{
    padding:10px 24px;
    background:#141414;
    color:${theme.white};
    border:none;

}
`

const CloseModalButton = styled(MdClose)`
cursor:pointer;
position:absolute;
top:5px;
right:5px;
height:20px;
width:32px;
padding:0;
z-index:10;
color:${theme.primary};
`


export const Modal = ({showModal, setShowModal}) =>{
const modalRef = useRef()

const animation = useSpring({
    config:{
        duration:250
    },
    opacity: showModal ?  1 : 0,
    transform:showModal ? `translateY(0%)`:`translateY(-100%)`
});

const closeModal = e =>{
    if(modalRef.current === e.target){
        setShowModal(false)
    }
}




    return (
        <div>
        {showModal ? (
            <Background ref={modalRef} onClick={closeModal}>
                <animated.div style={animation}>
                <ModalWrapper showModal={showModal}>
                    <ModalContent>
                        {/* <h1>Are you ready</h1>
                        <p>Get Exclusive access to our next launch</p>
                        <button>Join now</button> */}
                    <ContactUs/>
                    </ModalContent>
                    <CloseModalButton aria-label='Close-modal' onClick={()=> setShowModal(prev => !prev)} />
                </ModalWrapper>
                </animated.div>
            </Background>
     ) :null}
           
          </div>  
    ) };
